import cx from 'classnames';
import { Field, getIn, useFormikContext } from 'formik';
import FieldError from '../../forms/FieldError';
import Label from '../../forms/Label';
import RadioButton from '../../forms/RadioButton';
import { PropertyAssociationInfo } from '../../propertyAssociation/models/PropertyAssociationInfo';
import { PinboardMessageFormModel } from '../models/PinboardMessageFormModel';

type Props = {
    propertyAssociations: PropertyAssociationInfo[];
};

const PublishToSeveralOption = ({ propertyAssociations }: Props) => {
    const { values, errors, touched, submitCount } = useFormikContext<PinboardMessageFormModel>();
    const error = getIn(errors, 'targetAssociations');
    const isTouched = getIn(touched, 'targetAssociations');
    const showError = error && (isTouched || submitCount > 0);

    if (propertyAssociations.length === 3) {
        return (
            <div className="my-3">
                <RadioButton name="target" label="Alla boende (i alla mina engagemang)" value="all" />
            </div>
        );
    }

    return (
        <div className="my-3">
            <RadioButton name="target" label="Alla boende (i flera engagemang)" value="some" />
            {values.target === 'some' && (
                <div className="d-grid ms-4 ps-2">
                    <Label name="targetAssociations" text="Välj ett eller flera engagemang" />
                    <small id="targetAssociations-hint" style={{ letterSpacing: '-0.56px' }}>
                        Håll in <kbd style={{ all: 'revert' }}>CTRL</kbd> (Windows) eller <kbd style={{ all: 'revert' }}>CMD</kbd> (Mac) för att välja flera
                    </small>
                    <Field
                        as="select"
                        multiple
                        name="targetAssociations"
                        id="targetAssociations"
                        className={cx('form-control', showError && 'is-invalid')}
                        aria-details="targetAssociations-hint"
                        style={{ resize: 'vertical' }}
                    >
                        {propertyAssociations.map((association) => (
                            <option key={association.propertyAssociationId} value={association.propertyAssociationId}>
                                {association.name}
                            </option>
                        ))}
                    </Field>
                    <FieldError name="targetAssociations" errors={errors} touched={touched} ignoreTouched={showError} />
                </div>
            )}
        </div>
    );
};

export default PublishToSeveralOption;
